import React from 'react';
import * as Sentry from '@sentry/react';
Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
    release: process.env.MIX_SENTRY_RELEASE,
    environment: process.env.MIX_SENTRY_ENVIRONMENT,
    sendDefaultPii: true,
});
const ErrorBoundary = ({ children }) => (React.createElement(Sentry.ErrorBoundary, { fallback: React.createElement("p", null, "An error has occurred") }, children));
export default ErrorBoundary;
